import sessionReader from '../../store/readHelpers/SessionReader';
import utilService from '../../services/UtilService';

const RubricAdditionalResourceSelector = {
    selectRubricsUrl(rubricsContentItemId, rubricsContentRevisionId) {
        const BASE_RUBRICS_URL = '/rubrics?';
        const assessmentRunId = sessionReader.getAssessmentRunId();
        const mode = utilService.getRubricsUrlMode();
        const params = {
            contentItemId: rubricsContentItemId,
            mode,
            assessmentRunId,
        };

        if (rubricsContentRevisionId) {
            params.contentRevisionId = rubricsContentRevisionId;
        }

        const queryString = new URLSearchParams(params).toString();
        return `${BASE_RUBRICS_URL}${queryString}`;
    },
};

export default RubricAdditionalResourceSelector;
